export default __webpack_public_path__ + "static/media/69.5e6921bb.jpg";